import ReceivingIcon from './ReceivingIcon'

export default ReceivingIcon
